import { useQuery } from '@tanstack/react-query';
import type { Session } from '@supabase/supabase-js';
import { getSession } from '@/lib/auth/session';

/**
 * Reactive auth session. Subscribed once by `main.tsx` via
 * `supabase.auth.onAuthStateChange`, which writes the latest session
 * into `['session']` so all consumers re-render.
 */
export function useSession() {
  return useQuery<Session | null, Error>({
    queryKey: ['session'],
    queryFn: getSession,
    // The session is pushed into the cache by an external subscription
    // (see main.tsx); no need to revalidate on focus or interval.
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
